import { Component, OnInit } from '@angular/core'
import { BreadcrumbService } from 'src/app/shared/services/breadcrumb.service'

@Component({
  selector: 'app-error404',
  templateUrl: './error404.component.html',
  styleUrls: ['./error404.component.scss']
})
export class Error404Component implements OnInit {
  constructor(private breadcrumbService: BreadcrumbService) {}

  ngOnInit(): void {
    this.breadcrumbService.breadcrumbLinks.next([{ label: 'Error 404' }])
  }
}
